import type { Consumer } from '@tencent/polaris'; // TODO: 只在服务端引入

import isDev from '@utils/env/is-dev';
import isServer from '@utils/env/is-server';
import getPolarisConfig, { PolarisService } from '../polaris/index';
import { HttpPrefix } from '../wemeet-http-moudle';
import nodeAegisInfoAll from '../../lib/node-aegis';

interface GetUrlParam {
  prefix: HttpPrefix;
  path: string;
  hostName: string | undefined;
  tdeProxy?: boolean;
  usePolaris?: boolean;
  ctx?: any;
}

interface GetUrlRet {
  url: string;
  callback(success: boolean, cost?: number, code?: string): void;
}

const emptyCallBack = () => {};

// const TDE_POLARIS = {
//   namespace: 'Production',
//   service: '1089985:262144',
// };

const getUrl: (param: GetUrlParam) => Promise<GetUrlRet> = async ({
  prefix,
  path,
  hostName,
  tdeProxy = false,
  usePolaris = false,
  ctx,
}) => {
  const p = `${prefix}${path}`;

  // browser
  if (!isServer || /^https:\/\//.test(p)) {
    return {
      url: p,
      callback: emptyCallBack,
    };
  }

  // // 私有化 private web
  // if (process.env.WEMEET_PARAM_PRIVATE) {
  //   return {
  //     url: `${getPrivateHost()}${p}`,
  //     callback: emptyCallBack,
  //   };
  // }

  // server dev
  if (isDev || (isServer && !usePolaris)) {
    return {
      url: `http://${hostName}${p}`,
      callback: emptyCallBack,
    };
  }

  // server product
  if (!hostName) {
    throw new Error('host name is empty, check ctx');
  }
  try {
    return getServerUrl(p, hostName, tdeProxy, ctx);
  } catch (error) {
    return {
      url: `https://${hostName}${p}`,
      callback: emptyCallBack,
    };
  }
};

export default getUrl;

let consumer: null | Consumer = null;

async function getServerUrl(
  path: string,
  hostName: string,
  tdeProxy = false,
  ctx: any,
): Promise<GetUrlRet> {
  const startTime = Date.now();
  // 初始化北极星
  if (!consumer) {
    consumer = new (await import('@tencent/polaris')).Consumer();
  }

  let webPrefix = '';
  let polaris: PolarisService | undefined;
  if (!tdeProxy) {
    const cfg = getPolarisConfig(path);
    polaris = cfg.polarisConfig;
    webPrefix = cfg.webPrefix || '';
  } else {
    // polaris = TDE_POLARIS;
    // webPrefix = '';
    const cfg = getPolarisConfig(path, 'preRelease');
    polaris = cfg.polarisConfig;
    webPrefix = cfg.webPrefix || '';
  }

  if (polaris) {
    const isCICD = process.env.DEPLOY_ENV === 'ci';
    let metaData = {};
    if (isCICD) {
      const envNum = process.env.env || 'ci-200';
      metaData = { env: envNum };
      nodeAegisInfoAll(`使用CICD动态路由，env=${envNum}`, ctx);
    }
    const response = await consumer.select(polaris.namespace, polaris.service, metaData);
    if (!response) {
      // TODO: Polaris 调用失败上报
      nodeAegisInfoAll(`Polaris 调用失败, 使用默认值，耗时=${Date.now() - startTime}`, ctx);
      return {
        url: `https://${hostName}${path}`,
        callback: emptyCallBack,
      };
    }

    const {
      instance: { host, port },
    } = response;
    nodeAegisInfoAll(`Polaris 调用成功 ${host}:${port},耗时=${Date.now() - startTime}`, ctx);
    return {
      url: `http://${host}:${port}${path.replace(webPrefix, '')}`,
      callback(success, cost, code) {
        response.update(success, cost, code);
      },
    };
    /**
     * 通过 host, port 进行调用，
     * 并调用 `update` 上报调用结果
     * TODO: 调用结果上报，需要放到外层cgi调用非200错误码时处理
     **/
    // response.update(success, cost, code);
  }

  // 获取配置失败
  nodeAegisInfoAll(`Error: 未找到域名[${hostName}]与路径[${path}]的配置`, ctx);
  return {
    url: `https://${hostName}${path}`,
    callback: emptyCallBack,
  };
}
